export default "/assets/images/update-hero-img.7204dc1e2d372c39.png";